import { DateHelper } from "@eljouren/utils";
import trpcClient from "../../trpc-setup";
import { LiveBookingSuggestions } from "@eljouren/domain";
import { BookingSuggestionsFormValues } from "../../routes/sales/booking-suggestions/form/booking-suggestions-form-schemas";

type OriginalArgs = Extract<
  BookingSuggestionsFormValues,
  {
    type: "original";
  }
> & {
  isOnDuty: boolean;
  year: number;
};

type SimplifiedArgs = Extract<
  BookingSuggestionsFormValues,
  {
    type: "simplified";
  }
> & {
  isOnDuty: boolean;
};

export type SimplifiedBookingSuggestions = Awaited<
  ReturnType<
    BookingSuggestionsApiClient["findSimplifiedWorkOrderBookingSuggestions"]
  >
>;

export default class BookingSuggestionsApiClient {
  async findWorkOrderBookingSuggestions(
    args: OriginalArgs
  ): Promise<LiveBookingSuggestions.Type> {
    const defaultStart = new DateHelper().setHours(7).setMinutes(0).date;
    const defaultEnd = new DateHelper().setHours(16).setMinutes(0).date;

    return await trpcClient.bookingsRouter.findWorkOrderBookingSuggestions.query(
      {
        ...args,
        defaultWorkingHours: {
          start: defaultStart.toISOString(),
          end: defaultEnd.toISOString(),
        },
      }
    );
  }

  async findSimplifiedWorkOrderBookingSuggestions(args: SimplifiedArgs) {
    return await trpcClient.v2BookingSuggestionsRouter.getSimplifiedBookingSuggestions.query(
      args
    );
  }
}
